import React, { useEffect } from "react";
import styled from "@emotion/styled";
import BackHeader from "@components/header/BackHeader";
import { useQuery } from "@tanstack/react-query";
import { useApiRequest } from "@utils/ApiRequest";
import { useParams } from "react-router-dom";
import Stocked from "./_components/Stocked";
import SaleTemp from "./_components/SaleTemp";
import Sale from "./_components/Sale";
import StockTemp from "./_components/StockTemp";
import ProductInformation from "./_components/ProductInformation";

const ProductDetail = () => {
  const { getProductDetail } = useApiRequest();
  const { id, status } = useParams();

  console.log("id", id);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { data: productInfo, isLoading } = useQuery({
    queryKey: ["productInfo", id, status],
    queryFn: () => getProductDetail(id, status),
    enabled: !!id && !!status,
  });

  // console.log("디테일 페이지 productInfo", productInfo);
  return isLoading ? (
    <></>
  ) : (
    <Container>
      <BackHeader title="상품 정보" />

      {/* 임시저장 (재고등록 전) */}
      {status === "STOCK_TEMP" && <StockTemp productInfo={productInfo} />}

      {/* 재고등록 완료 */}
      {status === "STOCK" && <Stocked productInfo={productInfo} />}

      {/* 임시저장 (상품등록 전) */}
      {status === "SALE_TEMP" && <SaleTemp productInfo={productInfo} />}
      {/* 상품등록 완료 */}
      {status === "SALE" && <Sale productInfo={productInfo} />}
      <ProductInformation productInfo={productInfo} />
    </Container>
  );
};

export default ProductDetail;

const Container = styled.div({
  display: "flex",
  flexDirection: "column",
});
